import type { ConversationMode } from '@voicer/shared';

/**
 * Whether a typed (composer) turn should request TTS audio.
 * Audio is only useful once the controller has started the AudioContext (user gesture);
 * before that, chunks would queue on a suspended context and never play or mark ended.
 */
export function typedTurnWantsAudio(opts: {
  ttsEnabled: boolean;
  mode: ConversationMode;
  audioStarted: boolean;
}): boolean {
  return opts.ttsEnabled && opts.mode !== 'text' && opts.audioStarted;
}
